import { CircleAlert, LoaderCircle } from 'lucide-react';

export function LoadingState({ label = '正在加载' }: { label?: string }) {
  return (
    <div className="state-message" role="status">
      <LoaderCircle className="spin" aria-hidden="true" size={22} />
      <span>{label}</span>
    </div>
  );
}

export function ErrorState({ message }: { message: string }) {
  return (
    <div className="state-message state-message--error" role="alert">
      <CircleAlert aria-hidden="true" size={22} />
      <span>{message}</span>
    </div>
  );
}

export function StatusBadge({
  status,
  label,
}: {
  status: string;
  label: string;
}) {
  return <span className={`status-badge status-badge--${status}`}>{label}</span>;
}
